import React from "react";
import SelectCustomerForAddAdvertise from "../component/sections/advertise/coworker/SelectCustomerForAddAdvertise";
import AddAdvertiseCoworker from "../component/sections/advertise/coworker/banner/AddBanner";
import AllAdvertiseCoworker from "../component/sections/advertise/coworker/banner/AllBanner";
import EditAdvertiseCoworker from "../component/sections/advertise/coworker/banner/EditBanner";
import middleware from "./middlewares/middleware";

const coworkerAdvertiseRoutes = [
  {
    path: "/advertise/coworker/select-customer",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <SelectCustomerForAddAdvertise />,
        "SelectCustomerForAddAdvertise"
      );
    },
    exact: true,
  },
  {
    path: "/advertise/coworker/all/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllAdvertiseCoworker />,
        "AllAdvertiseCoworker"
      );
    },
    exact: true,
  },
  {
    path: "/advertise/coworker/banner/add/:userID/:campaignID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddAdvertiseCoworker />,
        "AddAdvertiseCoworker"
      );
    },
    exact: true,
  },
  {
    path: "/advertise/coworker/banner/edit/:userID/:advertiseID",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <EditAdvertiseCoworker />,
        "EditAdvertiseCoworker"
      );
    },
    exact: true,
  },

 
];

export default coworkerAdvertiseRoutes;
